import fetch from 'isomorphic-fetch';
import { DOTCOM_UX_ID } from '@nike/ux-tread-dotcom-constants';
import { addPageAction } from '@nike/ux-tread-new-relic';
import { getApiPathFromUrl } from '@nike/ux-tread-dotcom-utils';
import FetchResponseError from './fetch-response-error';
import formatDataWithWarnings from './format-data-with-warnings';
import zipkinWrapper from './zipkin-wrapper';
var defaultConfig = {
  pageActionName: 'fetch-client-pageAction'
};

/**
 * fetchClient is a wrapper for fetch with various nike apis
 *
 * @param  {string} url - The request url to complete the API call
 * @param  {object} fetchOptions - The request options to complete the API call
 * @param  {string} message - The message unique to the method
 * @param  {string} defaultConfig.pageActionName - An identifier to pass through to newrelic pageActions
 * @param  {string} defaultConfig.appName - zipkin name of applicatio
 * @returns {Promise} thenable parsed response from fetch request
 */
var fetchClient = function fetchClient(url, fetchOptions) {
  var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Fetch response error';
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultConfig,
    pageActionName = _ref.pageActionName,
    _ref$appName = _ref.appName,
    appName = _ref$appName === void 0 ? DOTCOM_UX_ID : _ref$appName;
  var _zipkinWrapper = zipkinWrapper(url, fetchOptions, {
      appName: appName
    }),
    tracer = _zipkinWrapper.tracer,
    options = _zipkinWrapper.options;
  return new Promise(function (resolve, reject) {
    return tracer.scoped(function () {
      return fetch(url, options).then(function (response) {
        // Since 204s return no content return an empty obj
        if (response.status === 204) {
          return resolve({});
        }
        if (response.status === 428) {
          var servicePath = getApiPathFromUrl(url);
          // NOTE we will possibly remove this page action later but need to test initially
          addPageAction(pageActionName, {
            url: url,
            servicePath: servicePath,
            message: 'recaptcha'
          });
          // rather than returning response we want to return an empty object akin to delete
          // that way we can handle retaining state downstream of this function call
          return resolve({});
        }

        // NOTE if we add a catch block to response.text, any internal catch inside .then will not work
        // and the external catch might not have context for a detailed message
        return response.text().then(function (txt) {
          var data = {};
          try {
            data = JSON.parse(txt);
            if (data.message || data.error || data.errors && data.errors.length) {
              reject(new FetchResponseError({
                url: url,
                data: data,
                options: options,
                response: response,
                message: data.message || message,
                pageActionName: pageActionName
              }));
            }
            resolve(formatDataWithWarnings({
              data: data,
              url: url
            }));
          } catch (e) {
            reject(new FetchResponseError({
              url: url,
              data: {
                error: {
                  message: 'Error parsing response data.'
                }
              },
              options: options,
              response: response,
              message: message,
              pageActionName: pageActionName
            }));
          }
        });
      });
    });
  });
};
export default fetchClient;